import React, { useState, useEffect } from 'react';
import { useLazyCommand, useEvent, useDomainEvent } from '@soap/modules';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../../ui/dialog';
import { Button } from '../../ui/button';

interface RemoveTagDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  tagId: string;
  tagName: string;
  onTagRemoved?: () => void;
}

export function RemoveTagDialog({ open, onOpenChange, tagId, tagName, onTagRemoved }: RemoveTagDialogProps) {
  const [submitting, setSubmitting] = useState(false);

  const [sendCommand] = useLazyCommand('C122v1_RemoveTag');
  const triggerCloseContextMenu = useDomainEvent({
    eventName: "close-context-menu",
  });

  // Close context menu when dialog opens
  useEffect(() => {
    if (open) {
      triggerCloseContextMenu();
    }
  }, [open, triggerCloseContextMenu]);

  useEvent({
    eventName: 'E106v1_TagRemoved',
    onEventReceived: () => {
      if (submitting) {
        setSubmitting(false);
        onOpenChange(false);
        onTagRemoved?.();
      }
    }
  }, [submitting, onOpenChange, onTagRemoved]);

  const handleConfirm = () => {
    setSubmitting(true);
    sendCommand({
      $type: 'C122v1_RemoveTag',
      C122_TagId: tagId
    });
  };

  const handleClose = () => {
    if (!submitting) {
      onOpenChange(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={handleClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Remove Tag</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <p>Please confirm you want to remove the tag "{tagName}"?</p>
          <p className="text-sm text-gray-600">This will remove it from any associated items.</p>
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={handleClose} disabled={submitting}>
            Cancel
          </Button>
          <Button type="button" variant="destructive" onClick={handleConfirm} disabled={submitting}>
            {submitting ? 'Removing...' : 'Remove Tag'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

